import React, { useCallback } from "react";
import { useSetAtom } from "jotai";
import { setRadioButtonsModalAtom } from "atoms/modalAtom/modalAtom";
import { useItemGroups } from "atoms/itemsGropAtom";
import { allItemGroups } from "constant-data/items";

import { Button } from "components/Button/Button";

export function MoveGroup() {
  const { itemGroupsState } = useItemGroups();
  const setMoveModal = useSetAtom(setRadioButtonsModalAtom);

  const handleClick = useCallback(() => {
    if (itemGroupsState.activeItemsGroup) {
      setMoveModal("Выберите группу для перемещения", true);
    }
  }, [itemGroupsState]);

  return (
    <Button
      onClick={handleClick}
      icon="move"
      disabled={
        !itemGroupsState.activeItemsGroup ||
        itemGroupsState.activeItemsGroup.itemgroupid ===
          allItemGroups.itemgroupid
      }
    >
      Переместить
    </Button>
  );
}
